import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-423d2cc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blog" }
const _hoisted_2 = { class: "blog-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blog-title" }, "POSTS", -1))
const _hoisted_4 = { class: "blog-count" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "meta" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "date" }
const _hoisted_10 = { class: "desc" }
const _hoisted_11 = {
  key: 0,
  class: "empty"
}

import ViewContainer from '../components/ViewContainer.vue';
import { articles } from '../blog/articles';

export default /*#__PURE__*/_defineComponent({
  __name: 'BlogIndexView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(ViewContainer, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(articles).length), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articles), (a) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: a.slug,
            to: `/posts/${a.slug}`,
            class: "article-pill"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: a.image,
                alt: "",
                class: "thumb"
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(a.title), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(a.date), 1)
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(a.description), 1)
              ])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128)),
        (!_unref(articles).length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "nothing here yet."))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})